export default "__VITE_ASSET__B3Yw83bc__"